'use strict';

/**
* Google Structured Data for Product Page
*/
function googleProductLoad() {
    var productData = $('#product-schema');
    if (productData.length > 0 && productData.val() !== '') {
        var e = document.createElement('script');
        e.type = 'application/ld+json';
        e.innerHTML = productData.val();
        var t = document.getElementsByTagName('script')[0];
        t.parentNode.insertBefore(e, t);
    }
}

module.exports = googleProductLoad;
